import { render, staticRenderFns } from "./Categories.edit.vue?vue&type=template&id=61a6ec6d&"
import script from "./Categories.edit.vue?vue&type=script&lang=js&"
export * from "./Categories.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports